module.exports = __webpack_public_path__ + "static-v-shop/1782224859977/img/mac.93cb7db8.png";